import {XauditModel} from '../../../models/xaudit.model';

export class ReportParameterModel extends XauditModel {
  ReportParameterID: string;
  ReportID: string;
  ParameterLabel: string;
  ParameterName: string;
  isSystemProvided: boolean;
  enumDataTypeID: string;
  isAllowMutiple: boolean;

  // ui only
  ParameterValueString: string;
  ParameterValueNumber: number;
  ParameterValueBoolean: boolean;
  ParameterValueDate: Date;
}


